import { accordion } from "./accordions";

(function ($) {
  "use strict";

  //Help function
  function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, "$1" + key + "=" + value + "$2");
    } else {
      return uri + separator + key + "=" + value;
    }
  }

  function init_state() {
    if (history.pushState) {
      window.addEventListener("popstate", function (e) {
        if (e.state && (e.state.htmlListView || e.state.clickedScroll)) {
          if (e.state.htmlListView) {
            var listAppendHolder = $("#main-page-content").find(
              ".result-set.ajax_append_holder"
            );
            listAppendHolder.html(e.state.htmlListView);
            if (e.state.newButtonHTML) {
              $("#main-page-content").find(".more_button_holder").html("");
              $("#main-page-content")
                .find(".more_button_holder")
                .append($(e.state.newButtonHTML));
            } else {
              $("#main-page-content").find(".more_button_holder").html("");
            }
          } else {
            window.location.reload(true);
          }
        }
      });
    }
  }

  // MAIN SEARCH, JUST REVEAL HIDDEN RESULTS
  $("js-show_more_ajax").click(function () {
    var pageLength = $(this).data("length");
    var total = $(this).data("total");
    var current = $(this).data("next");
    var next = current + pageLength;

    console.log("Show more!");

    next = next > total ? total : next;

    for (var i = current; i <= next; i++) {
      $("div#result_item_" + i).show();
    }

    $(this).data("next", next);
    var count = next === total ? next : next;
    $(".search-showing").html(count);
  });

  function show_more_button_init() {
    $(".more_button_holder").on("click", ".js-show_more_ajax", function (e) {
      e.preventDefault();
      if (history.pushState) {
        var listAppendHolder = $("#main-page-content").find(
          ".result-set.ajax_append_holder"
        );
        var dummy = $(this);
        var articleLoading = $(
          "<article id='article_loading'>" +
            "<div class='inner'>" +
            "<div class='content-holder'>" +
            "<p class='txt-center loading'><img src='_resources/themes/worksafe/images/three-dots.svg' alt='Animated loading image' /></p>" +
            "</div>" +
            "</div>" +
            "</article>"
        );
        var originalText = dummy.html(); //More ...
        var currentLink = $(this).data("link");
        dummy.html("Loading...");
        dummy.attr("disabled", "disabled");
        listAppendHolder.append(articleLoading);
        $.ajax(currentLink, {
          dataType: "json",
          error: function (jqXHR, textStatus, exception) {
            dummy.prop("disabled", true).html("Loading error");
          },
          success: function (jsonData, textStatus, jqXHR) {
            if (jsonData.nextLink) {
              var searchShowing = $(".search-showing");
              searchShowing.each(function (key, obj) {
                $(obj).html(jsonData.nextStart);
              });
            }

            if (jsonData.filterOnRegion) {
              if (jsonData.htmlListView1) {
                listAppendHolder
                  .find(".listView1")
                  .append(jsonData.htmlListView1);
                if ($("#accordion-list1-heading").hasClass("visuallyhidden")) {
                  $("#accordion-list1-heading").removeClass("visuallyhidden");
                  $("#accordion-list1-heading").find("button").click();
                  if (
                    $("#accordion-list2-heading")
                      .closest(".accordion")
                      .hasClass("open")
                  ) {
                    $("#accordion-list2-heading").find("button").click();
                  }
                } else {
                  if (
                    $("#accordion-list1-heading")
                      .closest(".accordion")
                      .hasClass("open")
                  ) {
                    var accordionContent = $("#accordion-list1-heading")
                      .closest(".accordion")
                      .find(".accordion-content");
                    accordionContent.show().animate({
                      height: accordionContent.prop("scrollHeight"),
                    });
                  }
                }
              }
              if (jsonData.htmlListView2) {
                listAppendHolder
                  .find(".listView2")
                  .append(jsonData.htmlListView2);
                $("#accordion-list2-heading").removeClass("visuallyhidden");
                if (
                  $("#accordion-list2-heading")
                    .closest(".accordion")
                    .hasClass("open")
                ) {
                  var accordionContent = $("#accordion-list2-heading")
                    .closest(".accordion")
                    .find(".accordion-content");
                  accordionContent.show().animate({
                    height: accordionContent.prop("scrollHeight"),
                  });
                }
              }
            } else {
              listAppendHolder.append($(jsonData.htmlListView));
            }

            if (jsonData.nextStart) {
              if (jsonData.nextLink) {
                var newDataLink = updateQueryStringParameter(
                  currentLink,
                  "start",
                  jsonData.nextStart
                );
                dummy
                  .data("link", newDataLink)
                  .attr("data-link", newDataLink)
                  .html(originalText);
              } else {
                dummy.hide();
              }
            } else {
              dummy.remove();
            }
          },
          complete: function (jqXHR, textStatus) {
            articleLoading.remove();
            dummy.removeAttr("disabled");

            if (textStatus == "success") {
              var newMoreButton = dummy.parent().html();
              var htmlListView = listAppendHolder.html();
              history.pushState(
                {
                  htmlListView: htmlListView,
                  pageTitle: "",
                  newButtonHTML: newMoreButton,
                },
                "",
                currentLink
              );
            }
            // init accordion if present in results
            accordion.initAccordion();
          },
        });
      } else {
        window.location.href = $(this).data("link");
      }
    });
  }

  $(document).ready(function () {
    init_state();
    show_more_button_init();
  });
})(jQuery);
